// english

export default {
  user_auth_title: 'User Authorization',
  user_auth_role: 'User Role',
  user_auth_customer_site_label: 'Customer / Site Authorization',
  // btn
  user_btn_change_password: 'Change Password',

  // conifrm
  user_confirm_save_title: 'Do you confirm to save?',

  user_confirm_disabled_title: 'Do you confirm to disabled this user?',
  user_confirm_content: "User's Name: {name}",
  user_confirm_delete_title: 'Do you confirm to delete this user?',

  // table
  user_table_userName: 'User Name',
  user_table_nickName: 'Nick Name',
  user_table_email: 'Email',
  user_table_belonged_customer: 'Belonged Customer',

  // form
  user_form_avatar: 'Avatar',
  user_form_role: 'Role',
  user_form_role_all: 'All roles',
  user_form_role_placeholder: 'Please select a role',
  user_form_userName_placeholder: 'Please input user name',
  user_form_userName_help:
    'Only character strings, numbers, letters, underscores, 6-32 digits are allowed, and cannot be modified saving. Please fill in carefully!',
  user_form_nickName_placeholder: 'Please input nick name',
  user_form_owner: 'Owner',
  user_form_owner_placeholder: 'Please select a customer',
  user_form_email_placeholder: 'Please input email',
  user_form_site_max: 'Allow Create Max Site',
  user_form_site_max_placeholder: 'Please input max site number',
  user_form_password: 'Password',
  user_form_password_placeholder: 'Please input password',

  user_privacy_title: 'Privacy Policy',
  user_privacy_check:
    'I have read and agree to the Privacy Policy of MBE Device Operation and Maintenance Platform (you can view the privacy policy in the Personal Center later)',
};
